import { z } from 'zod';

const InfoTypeEnum = z.enum(['loading', 'success', 'error']);
const displayConditionTypeEnum = z.enum(['always', 'ORYX_Admin']);

export const FileProcessUpdateSchema = z.object({
  variant: InfoTypeEnum,
  title: z.string(),
  message: z.string(),
  displayCondition: displayConditionTypeEnum,
  progress: z.number().min(0).max(1).optional(),
});

export type FileProcessUpdate = z.infer<typeof FileProcessUpdateSchema>;
